import { callAPI } from "./api";
export async function searchTrends({ accessToken, accessTokenSecret, q, }) {
    const requestBody = {
        accessToken,
        accessTokenSecret,
        q,
    };
    const responseBody = await callAPI("/search-trends", {
        method: "POST",
        notoast: true,
    }, requestBody);
    return responseBody;
}
